import React from 'react';
import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';

function Error({ data }) {
  const { profileLoginUrl } = data;

  return (
    <div className="mn_emailUnsubscribe">
      <ContentWrap className="mn_unsubscribeError">
        <div className="mn_alertInfo mn_warning">
          We're sorry. Your changes could not be saved.
          Please <a href={profileLoginUrl}>log in</a> and try again.
        </div>
      </ContentWrap>
    </div>
  );
}

export default Error;
